import script from "./PageFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=ts"

import "./PageFooter.vue?vue&type=style&index=0&id=3527500c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3527500c"]])

export default __exports__